import '.b6{height:2rem;}.ssr-plugin'
import '.af{flex-shrink:0;}.ssr-plugin'
import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import { RegionStatusRow } from './blocks/RegionStatusRow'
import { AvatarStack, AvatarStackProps } from '../avatarStack/AvatarStack'
import { Badge } from '@app/components/core/badge/Badge'
import Row from '@app/components/layout/Row'
import { Text } from '@app/components/core/typography/Text'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Style, styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/pro-solid-svg-icons'
import { useQuery } from '@based/sdk/react'
import { Card } from './Card'

export type MunicipalityCardProps = {
  id: number
  title: string
  to: string
  avatar?: string
  hasBadge?: boolean
  isLocked?: boolean
  description?: string
  plots?: number
  initiatives: number
  variant?: 'normal' | 'wide'
  wrapperStyle?: Style
} & Pick<AvatarStackProps, 'avatars'>

export const MunicipalityCard = ({
  id,
  title,
  to,
  avatar,
  hasBadge = false,
  isLocked,
  description,
  plots,
  initiatives,
  avatars,
  variant = 'normal',
  wrapperStyle,
}: MunicipalityCardProps) => {
  const followerCountQuery = useQuery('count-followers', {
    entityType: 'municipality',
    entityIds: [id],
  })

  const avatarStack = (
    <AvatarStack
      size={'extra-small'}
      avatars={avatars}
      total={followerCountQuery.data?.[0] ?? 0}
    />
  )

  return (
    <Card
      to={to}
      style={{
        overflow: 'hidden',
        display: 'flex',
        border: 'var(--border-subtle)',
        '&:hover': {
          border: '1px solid var(--brand-secondary)',
        },
        ...wrapperStyle,
      }}
    >
      <Column
        style={{
          justifyContent: 'space-between',
          minHeight: variant === 'wide' ? '12rem' : '16rem',
          width: '100%',
          position: 'relative',
        }}
      >
        <Column
          gap="0.5rem"
          alignItems="stretch"
          style={{
            width: '100%',
          }}
        >
          <Row
            style={{
              justifyContent: 'space-between',
            }}
          >
            <Avatar
              size="small"
              variant="yellow"
              shape="square"
              image={avatar}
              labelSource={title}
            />
            {isLocked && (
              <FontAwesomeIcon
                icon={faLock}
                style={{
                  color: 'var(--palette-blue-400)',
                  height: '1rem',
                  width: '1rem',
                }}
              />
            )}
          </Row>
          <Row
            gap="0.25rem"
            style={{ width: '100%', alignItems: 'center', alignSelf: 'start' }}
          >
            <Title.H4
              style={{
                minWidth: 0,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                margin: 0,
              }}
            >
              {title}
            </Title.H4>
            {hasBadge && <Badge />}
          </Row>
          {description && (
            <Text.Small
              style={{
                color: 'var(--palette-blue-500)',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {description}
            </Text.Small>
          )}
        </Column>
        {variant === 'wide' ? (
          <Row
            style={{
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              width: '100%',
            }}
          >
            <RegionStatusRow
              initiatives={initiatives}
              plots={plots}
              isLocked={isLocked}
            />
            <div className="b6 af">
              {avatarStack}
            </div>
          </Row>
        ) : (
          <Column gap="1.5rem" style={{ justifyContent: 'end' }}>
            <RegionStatusRow
              initiatives={initiatives}
              plots={plots}
              isLocked={isLocked}
            />
            <div className="b6">{avatarStack}</div>
          </Column>
        )}
      </Column>
    </Card>
  )
}
